import ChangePassModal from "./ChangePassModal";

export default ChangePassModal;